import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
/* eslint import/no-webpack-loader-syntax: off */

import { BrowserRouter as Router } from "react-router-dom";
import {BASE_URL} from './config/config'

// import worker from 'workerize-loader!./worker';
// let worker_instance = worker()  // `new` is optional

const worker_instance=null;
ReactDOM.render(
  // <React.StrictMode>
  <Router basename={BASE_URL}>
    <App worker={worker_instance} />
    </Router>
  // </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
